import React from 'react';
import {
    Card,
    Pic,
    Type,
    Title,
    TitleLink,
    Description,
    WrapperPrice,
    Price,
    PriceText,
    Button,
    Free,
    PromoPrice,
    Wrapper,
    Discount,
    Select
} from './styled';
import { connect } from 'react-redux';
import PopupCallback from '@ertelecom/ui-react/components/popups/popupCallback';
import PopupResult from '@ertelecom/ui-react/components/popups/popupResult';
import { buyItem } from '~/src/api/shop';
import Link from 'next/link';
import { selectDomain } from '~/src/store/selectors/domain';

class LotCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            orderStatus: false,
            isOpen: false,
            hasResult: false,
            resultTitle: '',
            resultDescription: '',
            resultClass: '',
            selectedOption: {},
            routerOptions: this.getOptions(this.props.data, this.props.price),
            buttonStatus: 'Подключено'
        };
    }

    componentDidMount() {
        this.setState({
            selectedOption: this.state.routerOptions[0]
        });
    }

    handleClose = () => {
        this.setState({
            isOpen: false
        });
    }

    percentCount = (price, promoPrice) => {
        const onePercent = price / 100;
        const newPrice = promoPrice / onePercent;
        const comparePercent = 100 - newPrice;
        const percent = Math.round(comparePercent);

        return ('-' + percent + '%');
    }

    getOptions = (data, possess) => {
        const options = [];

        data.forEach(item => {
            options.push({
                value: item.duration,
                label: `при рассрочке ${item.duration} мес.`,
                price: item.price,
                operType: 'leasing'
            });
        });

        if (possess > 0) {
            options.push({
                label: 'при покупке',
                price: this.props.promo ? this.props.promo : this.props.price,
                operType: 'possess'
            });
        }

        return options;
    }

    changeOptions = (option) => {
        this.setState({
            selectedOption: option,
        });
    }

    onSuccess = () => {
        this.setState({
            hasResult: true,
            resultTitle: 'Заявка отправлена успешно',
            resultDescription: 'Мы с вами свяжемся',
            resultClass: 'success'
        }, () => {
            this.setState({
                isOpen: false,
                orderStatus: true,
            });
        });
    }

    onFailure = () => {
        const text = 'Попробуйте позже';

        this.setState({
            hasResult: true,
            resultTitle: 'Заявка не отправлена',
            resultDescription: text,
            resultClass: 'error'
        }, () => {
            this.setState({
                isOpen: false
            });
        });
    }

    lotOrder = (itemId, priceType, leasingDuration, orderByCall) => {
        const { billingDomain, auth, onClickButton } = this.props;

        const setOrderStatus = orderStatus => this.setState({ orderStatus: orderStatus });

        if (onClickButton) {
            onClickButton({
                itemId,
                priceType,
                leasingDuration,
                orderByCall,
                setOrderStatus
            });
            return;
        }

        buyItem(billingDomain, auth.accessToken, itemId, priceType, leasingDuration);

        if (!orderByCall) {
            buyItem(billingDomain, auth.accessToken, itemId, priceType, leasingDuration)
                .then(
                    this.setState({
                        orderStatus: true,
                    })
                )
                .catch(err => {
                    console.log('error!', err.response);
                    this.onFailure();
                });
        } else {
            this.setState({
                isOpen: true,
                });
        }
    }

    checkButtonStatus = (text) => {
        if (text === this.state.buttonStatus) {
            return true;
        }
    }

    render() {
        const { selectedOption, orderStatus, isOpen, resultTitle, resultDescription, resultClass, hasResult, routerOptions } = this.state;
        const { description, name, price, button_text, image, type, promo, freeText, priceTextBoolean, orderId, orderByCall, exist, button_text_exists, link } = this.props;

        return (
            <React.Fragment>
                <Card>
                    <Pic background={`url(${image})`}/>
                    <Type>{type}</Type>
                    {link ? (
                        <Link href={link} passHref>
                            <TitleLink>{name}</TitleLink>
                        </Link>
                    ) : <Title>{name}</Title>}
                    <Free>{freeText}</Free>
                    <WrapperPrice>
                        {selectedOption && selectedOption.label === 'при покупке' && promo &&
                        <Wrapper>
                            <PromoPrice>{price}</PromoPrice>
                            <Discount>{this.percentCount(price, promo)}</Discount>
                        </Wrapper>}
                        <Wrapper>
                            <Price>
                                {!price && !promo && routerOptions.length === 0 ? '0' : selectedOption ? selectedOption.price : <>0<PriceText> ₽/мес - подключен до 01.05.2020</PriceText></>}
                            </Price>
                            {priceTextBoolean &&
                            <PriceText>
                                {selectedOption && selectedOption.label != 'при покупке' ? '₽/мес' : '₽'}
                            </PriceText>}
                            {this.props.data.length > 0 ? <Select options={routerOptions} minWidth='220px' value={selectedOption} onChange={this.changeOptions}/> : null}
                        </Wrapper>
                    </WrapperPrice>
                    <Description dangerouslySetInnerHTML={{ __html: description }}/>
                    <Button text={exist ? button_text_exists : !orderStatus ? button_text : button_text_exists} type={orderStatus ? 'secondary' : 'primary'} disabled={orderStatus || this.checkButtonStatus(button_text) || exist} onClick={() => this.lotOrder(orderId, selectedOption.operType, selectedOption.value, orderByCall)}/>
                </Card>
                <PopupCallback
                    isOpen={isOpen}
                    onClose={this.handleClose}
                    city={this.props.currentCity}
                    onSuccessShow={this.onSuccess}
                    onFailureShow={this.onFailure}
                    label='InternetOrder'
                />
                <PopupResult
                    isOpen={hasResult}
                    onClose={() => {
                        this.setState({ hasResult: false });
                    }}
                    title={resultTitle}
                    text={resultDescription}
                    type={resultClass}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    currentCity: state.city.currentCity,
    billingDomain: selectDomain(state),
});

export default connect(mapStateToProps)(LotCard);
